import { useMutation, useQueryClient } from '@tanstack/react-query'
import { removeExclusion } from 'api/wage/removeExclusion'
import { wageRuleKeys } from './keys'

export const useRemoveExclusionMutation = (ruleId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof removeExclusion>[0]) =>
      removeExclusion(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: wageRuleKeys.byId(ruleId),
      })
    },
  })
}
